import {
  isDesktop
} from './helpers';
import LazyLoad from "vanilla-lazyload";


const hamburgerWrapper = document.querySelector(".hamburger__wrapper");
const hamburger = document.querySelector(".hamburger");
const body = document.querySelector('body');
const navigation = document.querySelector('.navigation');
const hamburgerBackButton = document.querySelector('.navigation__main__menu__backbutton');

/**
 * Fixed nav
 */
/**
 * Fixed navigation and call-us button
 */
const fixedNav = document.querySelector('.header');
const uspsBar = document.querySelector('.usps');
const largeMenuB = document.querySelector('.navigation__large__submenu');

let offsetUsp = 132;
if (uspsBar) {
  offsetUsp = uspsBar.offsetTop;
}

if (document.querySelector('.header')) {

  window.addEventListener('scroll', function () {
    let scrollPosition = window.scrollY;
    let fixedNavOffsetHeight = document.querySelector('.header').offsetHeight;
    let offsetA = 115;
    let offsetB = 132;

    if (scrollPosition >= offsetA) {
      if (fixedNav) {
        fixedNav.classList.add('sticky');
      }
    } else {
      if (fixedNav.classList.contains('sticky')) {
        fixedNav.classList.remove('sticky');
      }
    }

    if (scrollPosition >= offsetB) {
      fixedNav.classList.add('active');
    } else {
      if (fixedNav.classList.contains('active')) {
        fixedNav.classList.remove('active');
      }
    }

    if (!body.classList.contains('vue-page')) {

      if (uspsBar && !uspsBar.classList.contains('sticky-stick')) {
        if (scrollPosition >= (offsetUsp - fixedNavOffsetHeight)) {
          if (uspsBar) {
            if (!uspsBar.classList.contains('sticky')) {
              // uspsBar.classList.add('sticky');
              // body.classList.add('usps--sticky')
            }
          }

        } else {
          if (uspsBar) {
            if (uspsBar.classList.contains('sticky')) {
              body.classList.remove('usps--sticky')
              uspsBar.classList.remove('sticky');
            }
          }
        }
      }

      if (largeMenuB && largeMenuB.classList.contains('active')) {
        if (uspsBar && uspsBar.classList.contains('sticky-stick')) {
          if (fixedNav.classList.contains('sticky') && fixedNav.classList.contains('active')) {
            largeMenuB.style.top = '132px';
          } else {
            largeMenuB.style.top = '200px';
          }
        } else if (uspsBar && uspsBar.classList.contains('sticky')) {
          if (fixedNav.classList.contains('sticky') && fixedNav.classList.contains('active')) {
            largeMenuB.style.top = '132px';
          } else {
            largeMenuB.style.top = '90px';
          }
        } else {
          if (fixedNav.classList.contains('sticky') && fixedNav.classList.contains('active')) {
            largeMenuB.style.top = '90px';
          } else {
            largeMenuB.style.top = '90px';
          }
        }
      }
    }
  });
}

/**
 * Toggle menu on menu-icon click
 */
if (hamburgerWrapper) {

  hamburgerWrapper.addEventListener("click", function () {
    toggleMenu();
  });
}

/**
 * Toggle menu on mobile if click on link with Anchor
 */
const navigationItems = document.querySelectorAll('.menu-item a');
if (navigationItems) {
  navigationItems.forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      if (e.target.hash) {
        toggleMenu();
      } else {
        return true;
      }
    })
  });
}

/**
 * Toggle mobile menu function
 */
function toggleMenu() {
  if (!isDesktop()) {
    hamburger.classList.toggle("is-active");
    body.classList.toggle('modal-open');

    if (body.style.overflow === 'hidden') {
      body.style.overflow = 'initial';
    } else {
      body.style.overflow = 'hidden';
    }
    body.classList.toggle('navigation-is-open');
    navigation.classList.toggle('navigation__is-open');
    hamburgerBackButton.classList.remove('active');
    closeAllSubMenus();
  }
}


/**
 * 
 * #########################
 * Desktop section
 * #########################
 * 
 */
if (isDesktop()) {
  const menuItems = document.querySelectorAll('.navigation .menu-item');
  const largeMenu = document.querySelector('.navigation__large__submenu');
  const backdrop = document.querySelector('.navigation__large__backdrop');
  const menuPicture = document.querySelector('.navigation__large__submenu__picture');

  if (menuItems) {
    [...menuItems].forEach((item) => {
      item.addEventListener('mouseover', () => {

        if (item.classList.contains('menu-item-has-children')) {
          if (menuPicture) {
            menuPicture.classList.add('lazy-on-hover');
            (function () {
              var ll = new LazyLoad({
                elements_selector: ".lazy-on-hover"
              });
            })();
          }


          largeMenu.classList.add('active');
          backdrop.classList.add('show');
          body.classList.add('sublarge-is-open');

          if (largeMenu && largeMenu.classList.contains('active')) {
            if (uspsBar && uspsBar.classList.contains('sticky-stick')) {
              if (fixedNav.classList.contains('sticky') && fixedNav.classList.contains('active')) {
                largeMenu.style.top = '132px';
              } else {
                largeMenu.style.top = '200px';
              }
            } else if (uspsBar && uspsBar.classList.contains('sticky')) {
              if (fixedNav.classList.contains('sticky') && fixedNav.classList.contains('active')) {
                largeMenu.style.top = '132px';
              } else {
                largeMenu.style.top = '90px';
              }
            } else {
              if (fixedNav.classList.contains('sticky') && fixedNav.classList.contains('active')) {
                largeMenu.style.top = '90px';
              } else {
                largeMenu.style.top = '90px';
              }
            }
          }


        }

      })
    })
  }

  if (largeMenu && backdrop) {
    document.addEventListener('mouseover', (e) => {
      if (document.querySelector('.navigation__large__submenu').classList.contains('active')) {
        if (e.target.classList.contains('navigation__large__backdrop')) {
          document.querySelector('.navigation__large__submenu').classList.remove('active');
          document.querySelector('.navigation__large__backdrop').classList.remove('show');
          body.classList.remove('sublarge-is-open');

        }

      }

    })
  }
}

/**
 * 
 * #########################
 * Mobile section
 * #########################
 * 
 */
const listItemsWithChildren = document.querySelectorAll('.menu-item-has-children');
const arrayListItemsWithChildren = [...listItemsWithChildren];
const mainMenu = document.querySelector('.navigation__main__menu');
const navWrapper = document.querySelector('.navigation__main__wrapper__menu__wrapper');
const backButton = document.querySelector('.back-button');

/**
 * Opening sub menu
 */
if (!isDesktop()) {
  if (arrayListItemsWithChildren) {
    arrayListItemsWithChildren.forEach(listItem => {
      let subMenu = listItem.querySelector('.sub-menu');
      let navAnchor = listItem.querySelector('.nav__anchor');

      listItem.addEventListener('click', (e) => {

        if (e.target.parentNode.parentNode.classList.contains('sub-menu')) {
          return true;
        } else {

          e.preventDefault();

          listItem.classList.add('sub-menu-active');
          subMenu.classList.add('active');

          let inlineItem = document.createElement('li');
          inlineItem.innerHTML = listItem.innerHTML;
          inlineItem.setAttribute('id', 'subMenuTitle');

          inlineItem.removeChild(inlineItem.querySelector('.sub-menu'));

          if (!subMenu.querySelector('#subMenuTitle')) {
            subMenu.prepend(inlineItem);
          }

          mainMenu.classList.add('navigation__main__menu__sub-is-active');
          body.classList.add('sub-menu-active');
          hamburgerBackButton.classList.add('active');

        }
      })

    })
  }

}

if (hamburgerBackButton) {

  hamburgerBackButton.addEventListener('click', (e) => {
    e.preventDefault();
    closeAllSubMenus();
    hamburgerBackButton.classList.remove('active');
  });
}


/**
 * Closing submenu
 */
function closeAllSubMenus() {
  arrayListItemsWithChildren.forEach(listItem => {
    let subMenu = listItem.querySelector('.sub-menu');
    let navAnchor = listItem.querySelector('.nav__anchor');

    listItem.classList.remove('sub-menu-active');
    subMenu.classList.remove('active');
    mainMenu.classList.remove('navigation__main__menu__sub-is-active');
    body.classList.remove('sub-menu-active');
  });
}